<style scoped lang="scss">
</style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/wms/customer/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('kehubianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kehumingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kehudizhi')">
						<el-input v-model="yt.conditions.address"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<template #buttonsL>
				<el-button v-if="utils.checkPower('web_wms_customer_add')" size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');" type="primary">
					{{$t('xinzeng')}}
				</el-button>
				<el-button size="mini" @click="show = !show" plain>
					{{$t('daoru')}}
				</el-button>
			</template>
			<template #buttonsR>
				<el-button v-if="utils.checkPower('web_wms_customer_batchImport')" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()" :loading="exportExcelLoading"></el-button>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_wms_customer_update')"  type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_wms_customer_delete')" type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/wms/customer/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 底部插槽 -->
			<template #footer>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('kehubianma')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kehumingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kehudizhi')" required>
						<el-input v-model="yt.editObj.address"></el-input>
					</el-form-item>
					<el-form-item :label="$t('lianxiren')">
						<el-input v-model="yt.editObj.contacts"></el-input>
					</el-form-item>
					<el-form-item :label="$t('lianxifangshi')">
						<el-input v-model="yt.editObj.contactsInfo"></el-input>
					</el-form-item>
					<el-form-item :label="$t('youxiang')">
						<el-input v-model="yt.editObj.email"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/wms/customer/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>


			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('kehubianma')" required>
						<el-input v-model="yt.editObj.code" disabled></el-input>
					</el-form-item>
					<el-form-item :label="$t('kehumingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kehudizhi')" required>
						<el-input v-model="yt.editObj.address"></el-input>
					</el-form-item>
					<el-form-item :label="$t('lianxiren')">
						<el-input v-model="yt.editObj.contacts"></el-input>
					</el-form-item>
					<el-form-item :label="$t('lianxifangshi')">
						<el-input v-model="yt.editObj.contactsInfo"></el-input>
					</el-form-item>
					<el-form-item :label="$t('youxiang')">
						<el-input v-model="yt.editObj.email"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/wms/customer/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>

		</el-dialog>
		<!-- 导入excel -->
		<importExcel :show.sync="show" />
	</div>
</template>
<script type="text/javascript">
	import importExcel from './import_excel'
	export default {
		name: 'wms_wms_customer_list',
		components: {
			importExcel
		},
		data() {
			return {
				show: false,
        exportExcelLoading:false,
				columns: [{
						label: 'kehubianma',
						prop: 'code',
						width: 150,
					},
					{
						label: 'kehumingcheng',
						prop: 'name'
					},
					{
						label: 'kehudizhi',
						prop: 'address'
					},
					{
						label: 'lianxiren',
						prop: 'contacts',
					},
					{
						label: 'lianxifangshi',
						prop: 'contactsInfo',
					},
					{
						label: 'youxiang',
						prop: 'email',
					},
					{
						label: 'chuangjianren',
						prop: 'createByObject.nickname',
					},
					{
						label: 'chuangjianshijian',
						prop: 'createTime',
						type: 'time'
					},
					{
						label: 'caozuo',
						type: 'slot',
						width: 180,
						fixed: 'right',
					},
				],
			};

		},

		created() {
			setTimeout(() => {
				this.yt.get(1);
				this.utils.event_hub.$on('WAREHOUSE_CUSTOMER_REFRESH', () => {
					this.yt.get(1);
				});
			}, 300)

		},
		methods: {
			exportExcel() {
        this.exportExcelLoading = true
			  let params = this.yt.conditions
			  return this.http.get('/web/report/export/wms_customer_export', {
			    params
			  }).then(res => {
			    this.$message.success(this.$t(res.msg))
			    this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
          this.exportExcelLoading = false
			  }).catch(error => {
			    this.$message.error(this.$t(error))
          this.exportExcelLoading = false
			  })
			},
		},
	};
</script>
